export function cdn(src, query='', mogr) {
  if (!src) return '';
  return src + (src.indexOf('?') > 0 ? '&' : '?') + (mogr ? 'imageMogr2' : 'imageView2') + query;
}
